<template>
  <div class="mt-4">
    <v-row>
      <v-col cols="12" md="4">
        <h4>2.7 Références catalogue</h4>
      </v-col>
      <v-col>
        <span v-if="!readOnly">
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="error"
                v-bind="attrs"
                v-on="on"
                @click.stop="promptConfirmDeletion()"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </template>
            <span>Supprimer toutes les références</span>
          </v-tooltip>
          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click.stop="append"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
            <span>Ajouter une référence</span>
          </v-tooltip>
          <v-tooltip bottom color="produit">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="produit"
                v-bind="attrs"
                v-on="on"
                @click.stop="importerCsv()"
              >
                <v-icon>mdi-file-import</v-icon>
              </v-btn>
            </template>
            <span>Importer depuis CSV</span>
          </v-tooltip>
        </span>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-data-table
        class="mt-0"
        :items="references"
        :headers="headers"
        no-data-text="Aucune référence"
        :hide-default-header="!references[0]"
        hide-default-footer
        disable-sort
        disable-pagination
        dense
      >
        <template v-slot:top>
          <produit-reference-dialog
            :show="showDialog"
            :editedRef="refEditee"
            @ok="confirmRefDialog"
            @cancel="cancelRefDialog"
          ></produit-reference-dialog>
        </template>
        <template v-slot:[`header.ui`]>
          <reference-unite-conditionnement
            abreviation="UI"
          ></reference-unite-conditionnement>
        </template>
        <template v-slot:[`header.cdt`]>
          <reference-unite-conditionnement
            abreviation="CDT"
          ></reference-unite-conditionnement>
        </template>
        <template v-slot:[`header.qml`]>
          <reference-unite-conditionnement
            abreviation="QML"
          ></reference-unite-conditionnement>
        </template>
        <template v-slot:[`item.ui`]="{ item }">
          {{ item.conditionnementEmploi }}
        </template>
        <template v-slot:[`item.cdt`]="{ item }">
          {{ item.quantiteEmploi }} par {{ item.conditionnementProtege }}
        </template>
        <template v-slot:[`item.qml`]="{ item }">
          {{ item.quantiteCommande }} UI
        </template>

        <template v-slot:[`item.tri`]="{ index }">
          <v-row
            v-if="references.length != 1 && !readOnly"
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              v-if="index != 0"
              icon
              color="info"
              @click.stop="moveUp(index)"
            >
              <v-icon>mdi-arrow-up-bold-circle</v-icon>
            </v-btn>
            <v-btn
              v-if="index != references.length - 1"
              icon
              color="info"
              @click.stop="moveDown(index)"
            >
              <v-icon>mdi-arrow-down-bold-circle</v-icon>
            </v-btn>
          </v-row>
        </template>

        <template v-slot:[`item.commands`]="{ item }">
          <v-row
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              icon
              color="info"
              @click.stop="edit(item)"
              :disabled="readOnly"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              icon
              color="primary"
              @click.stop="duplicate(item)"
              :disabled="readOnly"
            >
              <v-icon>mdi-plus-box-multiple</v-icon>
            </v-btn>
            <v-btn
              icon
              color="error"
              @click.stop="promptConfirmDeletion(item)"
              :disabled="readOnly"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="showDelConfirm" max-width="410">
        <v-card>
          <v-card-title class="text-h5">
            Confirmation de suppression
          </v-card-title>
          <v-card-text>
            <div v-if="deleteIndex != null">
              Confirmez-vous la suppression de la référence
              {{ refASupprimer }} ?
            </div>
            <div v-else>
              Confirmez-vous la suppression de toutes les références ?
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="doDeletion"> Oui </v-btn>
            <v-btn color="success" text @click="cancelDeletion"> Non </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <references-import-dialog
        :show="showImportCsv"
        @ok="showImportCsv = false"
        @cancel="showImportCsv = false"
      ></references-import-dialog>
    </v-row>
  </div>
</template>

<script>
import ProduitReferenceDialog from "./ProduitReferenceDialog";
import ReferencesImportDialog from "./ReferencesImportDialog";
import ReferenceUniteConditionnement from "./ReferenceUniteConditionnement";

export default {
  name: "ProduitReferences",
  components: {
    ProduitReferenceDialog,
    ReferencesImportDialog,
    ReferenceUniteConditionnement,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: " ", value: "tri" },
        { text: "Référence", value: "intitule" },
        { text: "UI", value: "ui" },
        { text: "CDT", value: "cdt" },
        { text: "QML", value: "qml" },
        { text: "Descriptif", value: "descriptif" },
        { text: " ", value: "commands" },
      ],
      showDelConfirm: false,
      showImportCsv: false,
      deleteIndex: null,
      showDialog: false,
      editIndex: null,
      refEditee: null,
    };
  },
  computed: {
    references() {
      return this.$store.state.demandeEditee.produit.references;
    },
    refASupprimer() {
      if (this.deleteIndex != null) {
        return this.references[this.deleteIndex].intitule;
      }
      return "";
    },
    // refEditee() {
    //   let index = this.editIndex;
    //   console.log("ref éditéee calculée");
    //   if (index != null) {
    //     //console.log(this.references[this.editIndex]);
    //     return this.references[index];
    //   }
    //   return null;
    // },
  },
  // watch: {
  //   editIndex(val) {
  //     console.log("editIndex Watcher");
  //     if (val != null) {
  //       //console.log(this.references[this.editIndex]);
  //       this.refEditee = this.references[val];
  //     }
  //     this.refEditee = null;
  //     //   let index = this.editIndex;
  //     //   console.log("ref éditéee calculée");
  //     //   if (index != null) {
  //     //     //console.log(this.references[this.editIndex]);
  //     //     return this.references[index];
  //     //   }
  //     //   return null;
  //     // },
  //   },
  // },
  methods: {
    promptConfirmDeletion(item) {
      if (item) {
        this.deleteIndex = this.references.indexOf(item);
      }
      this.showDelConfirm = true;
    },
    doDeletion() {
      if (this.deleteIndex != null) {
        this.$store.dispatch("demandeEditee/removeReference", this.deleteIndex);
        this.deleteIndex = null;
      } else {
        this.$store.dispatch("demandeEditee/clearReferences");
      }
      this.showDelConfirm = false;
    },
    cancelDeletion() {
      this.deleteIndex = null;
      this.showDelConfirm = false;
    },
    confirmRefDialog(ref) {
      if (this.editIndex != null) {
        this.$store.dispatch("demandeEditee/updateReference", {
          index: this.editIndex,
          ref,
        });
      } else {
        this.$store.dispatch("demandeEditee/addReference", ref);
      }
      this.showDialog = false;
    },
    cancelRefDialog() {
      this.showDialog = false;
    },
    append() {
      this.editIndex = null;
      this.showDialog = true;
    },
    edit(item) {
      this.editIndex = this.references.indexOf(item);
      this.refEditee = Object.assign({}, item);
      this.showDialog = true;
    },
    moveUp(index) {
      this.$store.dispatch("demandeEditee/moveReferenceUp", index);
    },
    moveDown(index) {
      this.$store.dispatch("demandeEditee/moveReferenceDown", index);
    },
    duplicate(item) {
      let newRef = Object.assign({}, item);
      this.$store.dispatch("demandeEditee/addReference", newRef);
      this.edit(newRef);
    },
    importerCsv() {
      this.showImportCsv = true;
    },
  },
};
</script>

<style></style>
